import { EULA_VERSION_HEADER, PRIVACY_VERSION_HEADER } from "./eula.controller";
export const name = '$gzEULA';
export default function $gzEULA(
  $log,
  $mdDialog,
  rnHttp
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let service = {
    show,
    getCurrentVersion,
    getPrivacyVersion,
  };
  return service;

  /////////////////

  function show(requireAccept = false, $event = null, inSignin = false, isChanged = false) {
    // $log.debug('$gzEULA#show: Open EULA');
    return openEulaDialog(requireAccept, $event, isChanged)
      .then(result => {
        if(inSignin) {
          // go back to the signin state machine
          return result;
        }
      });
  }

  function openEulaDialog(requireAccept, $event, isChanged) {
    return $mdDialog.show({
      targetEvent: $event,
      template: require('./eula.jade'),
      controller: 'EulaController',
      bindToController: true,
      controllerAs: 'terms',
      locals: {
        requireAccept: requireAccept,
        isChanged: isChanged
      }
    })
      .catch(error => {
        // User cancelled dialog
      });
  }

  function getCurrentVersion() {
    return rnHttp.head('portal_service', '/i18n/eula/en', {cache: true}).then(resp => {
      return resp.headers(EULA_VERSION_HEADER);
    });
  }

  function getPrivacyVersion() {
    return rnHttp.head('portal_service', '/i18n/eula/en', {cache: true}).then(resp => {
      return resp.headers(PRIVACY_VERSION_HEADER);
    });
  }
}
